// extracted by mini-css-extract-plugin
module.exports = {"root":"ScaleBlock_root__Hv69u","grid":"ScaleBlock_grid__oZWqR","card":"ScaleBlock_card__p8Rdn","gif":"ScaleBlock_gif__vlq81","slider":"ScaleBlock_slider__NNQW8"};